"use client";

import React from "react";
import { usePopup } from "./PopupContext";
import MergeProfilesPopup from "../components/MergeProfilesPopup";
import SuccessPopup from "../components/SuccessPopup";
import MainMemberProfilePopup from "../components/MainMemberProfilePopup";
import MainMemberMedicalAidPopup from "../components/MainMemberMedicalAidPopup";
import BeneficiariesPopup from "../components/BeneficiariesPopup";

export default function PopupHost({ onCloseAll }) {
  const { activePopup, popupData, closePopup } = usePopup();

  const handleClose = () => {
    closePopup();
    if (onCloseAll) {
      onCloseAll();
    }
  };

  if (!activePopup) return null;

  switch (activePopup) {
    case "mergeProfiles": {
      const { profiles } = popupData || {};
      return <MergeProfilesPopup overlay={true} profiles={profiles || []} onClose={handleClose} />;
    }
    case "success":
      return <SuccessPopup overlay={true} onClose={handleClose} />;
    case "mainMemberProfile": {
      const { mergedProfile } = popupData || {};
      return <MainMemberProfilePopup overlay={true} onClose={handleClose} data={mergedProfile} />;
    }
    case "mainMemberMedicalAid": {
      const { mergedProfile } = popupData || {};
      return <MainMemberMedicalAidPopup overlay={true} onClose={handleClose} data={mergedProfile} />;
    }
    case "beneficiaries": {
      const { mergedProfile } = popupData || {};
      return <BeneficiariesPopup overlay={true} onClose={handleClose} data={mergedProfile} />;
    }
    default:
      return null;
  }
}
